import { useMemo } from 'react';

export default function useSelectedOption(optionsArray, propertyToCompare, comparableState) {
  useMemo(
    () => optionsArray.find((item) => item.compare === comparableState) || null,
    [comparableState, optionsArray],
  );
}
